import { LoaderFunction, MetaFunction } from "@remix-run/node";
import { Link, useLoaderData } from "@remix-run/react";
import { t } from "i18next";
import { LogIn } from "lucide-react";
import { checkAuth, requireAdminRole, requireAuth } from "~/utils/auth.server";

export const meta: MetaFunction = () => {
  return [
    { title: t("navigation.imprint") },
    {
      name: "description",
      content: "Impressum",
    },
  ];
};

export const loader: LoaderFunction = async ({ request }) => {
  try {
    const userToken = await checkAuth(request);
    return { userToken };
  } catch (err) {
    console.error(err);
    return err;
  }
};

export default function Impressum() {
  const userToken = useLoaderData<typeof loader>() || {};
  return (
    <div className="container mx-auto px-4 py-10">
      <div className="mb-10 cursor-pointer flex self-center p-2 ml-5">
        <img
          src="http://sgb.blatt.tools/app/assets/logo.svg"
          alt="SGB Logo"
          className="max-h-28 min-w-28"
        ></img>
      </div>
      {!userToken?.userToken && (
        <Link
          to="/login"
          className="flex justify-end items-center gap-2 text-sm "
        >
          <div className="flex justify-end items-center gap-2 p-4 hover:bg-slate-400 hover:text-white transition-all duration-500 ">
            <LogIn className="w-4 h-4" />
            <p>Login</p>
          </div>
        </Link>
      )}

      <div className="mb-10 flex flex-col gap-4 border-t border-black rounded-lg"></div>
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-medium">{t("navigation.imprint")}</h1>
        <p className="text-sm font-light">Angaben gemäß § 5 TMG:</p>
        <p className="text-lg">SGB Energiehandel GmbH</p>
        <p className="text-sm font-light">
          Industriestraße 29-31 <br />
          82194 Gröbenzell
        </p>
        <p className="text-lg">Vertreten durch</p>
        <p className="text-sm font-light">
          Dipl.-Ing. & Dipl.-Kfm. Norman Köhler 
        </p>
        <p className="text-lg">Kontakt</p>
        <p className="text-sm font-light">
          Telefon: +49 (0)800 3347112 <br />
          Telefax: <br />
          E-Mail: info@sgb-energie.de
        </p>
        <p className="text-lg">Eintragung im Handelsregister</p>
        <p className="text-sm font-light">Registernummer: HRB252484</p>
        <p className="text-lg">Umsatzsteuer-ID</p>
        <p className="text-sm font-light">
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
        </p>
      </div>
    </div>
  );
}
